<template>
    <div>
        <config-main-title>
            Simpro {{ versao_selecionada ? (' / ' + versao_selecionada.search) : '' }}
        </config-main-title>
        
        <div class="row mb-3">
            <div class="col col-12 col-md-6">
               <az-input v-model="search">
                    <template v-slot:button-pre>
                        <div class="input-group-prepend" v-if="versao_selecionada">
                            <button class="btn btn-outline-primary" type="button" id="button-addon1" @click="load()">
                                <i class="fas fa-sync-alt"></i>
                            </button>
                        </div>
                    </template>
                    <template v-slot:buttonposb>
                        <div class="input-group-prepend" v-if="versao_selecionada">
                            <button type="button" class="btn btn-outline-primary" @click="editar_nome_tabela()">
                                <i class="fas fa-edit"></i>
                            </button>
                        </div>
                        <importacao 
                            service="simpros" 
                            @refresh="load_simpro()" 
                            :parms="{ id_tabela_versao: versao_selecionada ? versao_selecionada.id_tabela_versao : null }"  
                            v-if="versao_selecionada" 
                        />
                    </template>
                </az-input>
            </div>

            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir Versão
                </button>
            </div>

            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example" v-if="versao_selecionada">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
                <div class="btn-group mb-1" role="group" aria-label="Basic example" v-else>
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
        </div>
        
        <div v-if="listaVersao && listaVersao.length && !versao_selecionada">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in listaVersao" :key="id">
                    <span>
                        <a href="#" @click.prevent="selecionar_versao(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input"
                                :id="'ativo-' + id"
                                v-model="dado.fl_ativo"
                                @change="toggle_versao(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <div v-if="(!lista || !lista.length) && versao_selecionada">
            <az-empty-state
                :msg="'Nenhum item da tabela Simpro Identificado.'"
                icon="fas fa-search" />
		</div>

        <div v-else-if="versao_selecionada">

            <small>{{ dados.from }} - {{ dados.to }} / {{ dados.total }}</small>
            <table class="table bg-white table-hover table-sm cabecalho-fixo">
                <thead>
                    <tr>
                        <th>Cod. Simpro</th>
                        <th>Cod. Tuss</th>
                        <th>Descrição</th>
                        <th>Vigência</th>
                        <th>Embalagem</th>
                        <th>Qtd Emb.</th>
                        <th class="text-right text-info">PFE</th>
                        <th class="text-right text-info">PFF</th>
                        <th class="text-right text-success">PVE</th>
                        <th class="text-right text-success">PVF</th>
                        <th class="text-right text-warning">PUE</th>
                        <th class="text-right text-warning">PUF</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, iix) in lista" :key="iix">
                        <td class="text-nowrap">{{ item.st_codigo_simpro }}
                            <span class="badge badge-secondary">{{ item.st_tipo_alteracao }}</span>
                        </td>
                        <td>
                            {{ item.st_codigo_tuss }}
                        </td>
                        <td>{{ item.st_descricao }}</td>
                        <td>{{ $util.getFormatDate(item.dt_data_vigencia) }}</td>
                        <td>
                            {{ item.st_tipo_embalagem }} / {{ item.st_tipo_fracionamento }}
                        </td>
                        <td>
                            {{ item.in_quantidade_embalagem }}
                        </td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_preco_fabricante_embalagem) }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_preco_fabricante_fracionado) }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_preco_venda_embalagem) }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_preco_venda_fracionado) }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_preco_usuario_embalagem) }}</td>
                        <td class="text-right">{{ $util.formatMoeda(item.dc_preco_usuario_fracionado) }}</td>
                        <td class="text-right">
                            <az-audit-log-button sizing="sm" :link="true" model="simpro" :id="item.id_simpro" class="p-0" />
                        </td>
                    </tr>
                </tbody>
            </table>

            <br><br><br><br><br>
        </div>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3 d-flex justify-content-between">
            <paginate
                v-if="dados && dados.last_page > 1"
                class="mb-0"
                :page-count="dados.last_page"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :prev-text="'<<'"
                :next-text="'>>'"
                :click-handler="paginar">
            </paginate>
            <div class="d-flex" v-if="dados && dados.last_page > 1">
                <div class="d-flex flex-column">
                    <small><span class="text-info">PFE</span> - Preço Fabricante Embalagem</small>
                    <small><span class="text-info">PFF</span> - Preço Fabricante Fracionado</small>
                </div>
                <div class="d-flex flex-column pl-2">
                    <small><span class="text-success">PVE</span> - Preço Venda Embalagem</small>
                    <small><span class="text-success">PVF</span> - Preço Venda Fracionado</small>
                </div>
                <div class="d-flex flex-column pl-2">
                    <small><span class="text-warning">PVE</span> - Preço Usuário Embalagem</small>
                    <small><span class="text-warning">PVF</span> - Preço Usuário Fracionado</small>
                </div>
            </div>
            <div v-if="versao_selecionada">
                <button type="button" class="btn btn-secondary mx-2" @click="fechar()">
                    Fechar
                </button>
                <button type="button" class="btn btn-primary" @click="atualizarPrecos()">
                    Atualizar Preços
                </button>
            </div>
        </nav>

        <tabela-atualizar-precos ref="tabelaAtualizarPrecos"/>
        
        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Versão Simpro
                            {{ item.id_tabela_versao ? '#' + item.id_tabela_versao : 'Nova' }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_nome" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="incluir_versao ()">{{ item.id_tabela_versao ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <pre v-if="false">{{ dados }}</pre>
    </div>
</template>


<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
//import AzSubmit from '../../util/AzSubmit.vue';
//import AzSubTitle from '../../util/AzSubTitle.vue';
import Importacao from '../shared/Importacao.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import TabelaAtualizarPrecos from "../../cadastros/shared/TabelaAtualizarPrecos.vue";

export default {
    data () {
        return {
            breadcrumb: null,
            search: "",
            viewMode: 'A',
            dados: null,
            page: 1,
            versoes: [],
            versao_selecionada: null,
            item: null,
            validate: false,
        };
    },

    components: {
        ConfigMainTitle,
        Importacao,
        AzEmptyState,
        AzInput,
        TabelaAtualizarPrecos,
        AzAuditLogButton,
        AzSubmit
    },

    computed: {
        lista: function () {
            if ( !this.dados || !this.dados.data )
                return null;

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return (this.dados && this.dados.data && this.dados.data.length) ? 
                this.dados.data.filter (item => { 
                    return ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

        listaVersao: function () {
            if ( !this.versoes )
                return null;

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return (this.versoes && this.versoes.length) ? 
                this.versoes.filter (item => { 
                    return (!this.search || reg.test(JSON.stringify(item))) &&
                        (this.viewMode == 'A' ? item.fl_ativo : true);
                }) : null;
        }
    },

    methods: {
        editar_nome_tabela () { 
            this.item = _.cloneDeep(this.versao_selecionada);
            $('#edicaoModal').modal('show');
        },

        incluir() {
            this.item = {
                st_nome: "",
                id_unidade: 1,
                st_versao: '1',
                ch_tipo_tabela: 'P',
                st_aplicacao: 'SMP',
                dc_valor_uco: 0,
                dc_valor_filme: 0,
                fl_ativo: true,
                fl_moeda_corrente: true,
                fl_tem_imagem: false,
                fl_tem_cirurgia: false,
            };

            $('#edicaoModal').modal('show');
        },

        incluir_versao() {
            this.$util.atualizar(this, { 
                service: 'tabela_versaos',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });

            this.versao_selecionada = null;
            this.dados = null;
        },

        fechar() {
            this.versao_selecionada = null;
            this.dados = null;
        },

        selecionar_versao(dado) {
            this.versao_selecionada = dado;
            this.load_simpro();
        },

        toggle_versao(dado) {
            this.$util.toggle(this, {
                service: "tabela_versaos",
                dados: dado,
            });
        },

        load_simpro() {
            this.$util.load(this, {
                service: "simpros",
                parms: {
                    search: this.search,
                    size: 100,
                    page: this.page,
                    id_tabela_versao: this.versao_selecionada.id_tabela_versao,
                },
                page: this.page,
                size: 100,
            });
        },

        load() {
            if(this.versao_selecionada) {
                this.load_simpro();
            } else {
                this.$util.load(this, { 
                    service: "tabela_versaos",
                    parms: { 
                        simpro: true,
                        cadastro: true,
                    },
                    loadTo: res => { 
                        this.versoes = res;
                    }
                });
            }
        },

        atualizarPrecos() {
            this.$refs.tabelaAtualizarPrecos.show('simpro');
        },

        paginar (page) {
            this.page = page;
            this.load_simpro();
        },
    },

    mounted () {
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Simpro" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },
}
</script>
